import React from 'react'
import BreadCrumb from '../../../../layout/BreadCrumb'
import Header from './Header'
import OverviewTabList from './overview-tab/OverviewTabList'
import { useSelector } from 'react-redux';

function ViewList() {
  const { loading, activeObjOngoingProject } = useSelector((state) => ({
    loading: state.fetch.loading,
    activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
  }));
  return (
    <div>
         <BreadCrumb
              breadcrumbs={[
                { title: "Projects", path: "back" },
                { title: `Overview ${activeObjOngoingProject?.projectName}`},
              ]}/>

              <Header/>
              <OverviewTabList/>
    </div>
  )
}

export default ViewList
